/**
 * Currently supported IDV methods for Lending.
 */
export enum IDVMethod {
    IN_HOUSE = "IN_HOUSE",
    VERIFF = "VERIFF",
    MANUAL = "MANUAL"
}



// WEBPACK FOOTER //
// ./src/constants/IDVMethod.ts